import React, { useEffect, useState } from 'react';
import '../../App.css';
import ContactForm from '../ContactForm.js';
import Footer from '../Footer';
import Popup from 'reactjs-popup';
import Cookies from 'js-cookie';
import { InstagramEmbed } from 'react-social-media-embed';
import video from '../../old_film_texture.mp4'
import Navbar from '../Navbar.js';

function Home() {
  const [showPopup, setShowPopup] = useState(true);
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const hasVisited = Cookies.get('visited');
    const hasConsented = Cookies.get('cookieConsent');
  
    if (!hasVisited) {
      setShowPopup(true); // Only show popup if not visited
    }
  
    if (!hasConsented) {
      setShowCookieBanner(true); // Show cookie banner separately
    }
  }, []);

  const handleCookieConsent = () => {
    Cookies.set('cookieConsent', 'true', { expires: 365 });
    setShowCookieBanner(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log('Submitting email:', email);
      await fetch(
        'https://script.google.com/macros/s/AKfycbzCgCQo_NnpxW1rbIitT0blDbVHxJ6TetEwrG7v3gW4g2G2pnN6Cw6VKUnY2HMUZI6B/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          body: JSON.stringify({ email }),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      
      setSubmitted(true);
      setShowPopup(false);
    } catch (error) {
      console.error('Error submitting email:', error);
    }
  };

  return (
    <>
        <Navbar />
      <div id='home' style={{translate: '0 -10rem'}}></div>

      {/* Auto Popup */}
      
      <Popup open={showPopup} modal onClose={() => setShowPopup(false)}>
        <section className='newsletter-popup'>
          <p className='newsletter-popup-heading'>
            Join our mailing list to get updated on new music, merch, and show dates!
          </p>
          <form onSubmit={handleSubmit}>
            <input
              className='newsletter-popup-input'
              name='email'
              type='email'
              placeholder='Your Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className='button-horizontal-wrapper'>
              <button className='newsletter-button' type='submit'>
                Submit
              </button>
              <button
                className='newsletter-button'
                type='button'
                onClick={() => setShowPopup(false)}
              >
                Nah
              </button>
            </div>
          </form>
        </section>
      </Popup>

      {/* Main Content */}

      <div className='home-header'>
        <div className='home-header-image'>
          <video
            className="header-overlay-video"
            src={video}
            type="video/mp4"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>

      <div className='main-content-container'>
        <div className='background-texture'>

          <div id='shows' style={{translate: '0 -10rem'}} ></div>
          <div className='card-title' id='shows' style={{ marginTop: '50px' }}>
            <h2>SHOWS</h2>
          </div>

          <div className='card'>
            <div className='show-card'>
                <p style={{ textAlign: 'left' }}>June 26th, 2026</p>
                <p style={{ textAlign: 'left' }}>Fremont Fridays <br/> <p style={{ fontStyle: 'italic',  color: '#BABABA'}}> Fremont, WA </p> </p>
                <a href='https://www.fremontfridaysseattle.com/about-1'>
                  <button className='show-button'>
                    <p style={{ fontWeight: 'bold' }}>INFO</p>
                  </button>
                </a>
            </div>
            <div className='show-card'>
              <p style={{ textAlign: 'left' }}>June 27th, 2026</p>
              <p style={{ textAlign: 'left' }}>Muckleshoot Casino <br/> <p style={{ fontStyle: 'italic',  color: '#BABABA'}}> Tacoma, WA </p> </p>
              <a href='https://muckleshootcasino.com/entertainment'>
                <button className='show-button'>
                  <p style={{ fontWeight: 'bold' }}>INFO</p>
                </button>
              </a>
            </div>
            <div className='show-card'>
              <p style={{ textAlign: 'left' }}>July 11th, 2026</p>
              <p style={{ textAlign: 'left' }}>Ballard Seafood Fest <br/> <p style={{ fontStyle: 'italic',  color: '#BABABA'}}> Ballard, WA </p> </p>
              <a href='https://seafoodfest.org/'>
                <button className='show-button'>
                  <p style={{ fontWeight: 'bold' }}>INFO</p>
                </button>
              </a>
            </div>
            <div className='show-card'>
              <p style={{ textAlign: 'left' }}>August 1st, 2026</p>
              <p style={{ textAlign: 'left' }}>Pioneer Square Fest <br/> <p style={{ fontStyle: 'italic',  color: '#BABABA'}}> Seattle, WA </p> </p>
              <a href='https://pioneersquarefest.com/store/'>
                <button className='show-button'>
                  <p style={{ fontWeight: 'bold' }}>TICKETS</p>
                </button>
              </a>
            </div>

            {/* <div className='show-card'>
              <p style={{ textAlign: 'left' }}>September 20, 2025 <br/> </p>
              <p style={{ textAlign: 'left' }}>EP Release Show <br/> <p style={{ fontStyle: 'italic',  color: '#BABABA'}}> Seattle, WA </p> </p>
              <div className='button-container'>
                <a href='https://www.ticketweb.com/event/babes-in-canyon-album-release-tractor-tickets/13869904?pl=tractor&REFID=clientsitewp'>
                  <button className='show-button'>
                    <p style={{ fontWeight: 'bold' }}>TICKETS</p>
                  </button>
                </a>
              </div>
            </div> */}

          </div>

          <div id='music' style={{translate: '0 -5rem'}}></div>
          <div className='card-title'>
            <h2>MUSIC</h2>
          </div>

          <div className='card'>
            <div className='music-card'>

              <div className='music-container'>
                <div className='music-cover-intothefade'></div>
                <div className='music-button-container'>
                  <a href='https://distrokid.com/hyperfollow/joylared/into-the-fade '>
                      <button className='music-button'>
                        <p style={{ fontWeight: 'bold', alignItems: 'left' }}>LISTEN</p>
                      </button>
                  </a>
                </div>
                <p style={{ textAlign: 'left', fontStyle: 'italic', marginTop: '4px' }}>
                  Into the Fade
                </p>
                <p style={{ textAlign: 'left', fontStyle: 'italic' }}>2025</p>
              </div>

              <div className='music-container'>
                <div className='music-cover-nightclubs'></div>
                <div className='music-button-container'>
                <a href='https://distrokid.com/hyperfollow/joylared/are-there-nightclubs-in-heaven'>
                    <button className='music-button'>
                      <p style={{ fontWeight: 'bold', alignItems: 'left' }}>LISTEN</p>
                    </button>
                  </a>
                </div>
                <p style={{ textAlign: 'left', fontStyle: 'italic', marginTop: '4px' }}>
                  Are There Nightclubs in Heaven?
                </p>
                <p style={{ textAlign: 'left', fontStyle: 'italic' }}>2025</p>
              </div>

              <div className='music-container'>
                <div className='music-cover-doctor'></div>
                <div className='music-button-container'>
                <a href='https://distrokid.com/hyperfollow/joylared/doctor-can-you-fix-me'>
                    <button className='music-button'>
                      <p style={{ fontWeight: 'bold', alignItems: 'left' }}>LISTEN</p>
                    </button>
                  </a>
                </div>
                <p style={{ textAlign: 'left', fontStyle: 'italic', marginTop: '4px' }}>
                  Doctor (Can You Fix Me?)
                </p>
                <p style={{ textAlign: 'left', fontStyle: 'italic' }}>2025</p>
              </div>

              <div className='music-container'>
                <div className='music-cover-highandlow'></div>
                <div className='music-button-container'>
                  <a href='https://distrokid.com/hyperfollow/joylared/high-and-low'>
                    <button className='music-button'>
                      <p style={{ fontWeight: 'bold' }}>LISTEN</p>
                    </button>
                  </a>
                </div>
                <p style={{ textAlign: 'left', fontStyle: 'italic', marginTop: '4px' }}>
                  High and Low
                </p>
                <p style={{ textAlign: 'left', fontStyle: 'italic' }}>2024</p>
              </div>
            </div>
          </div>

          <div id='videos' style={{translate: '0 -5rem'}}></div>
          <div className='card-title'>
            <h2>VIDEOS</h2>
          </div>

          <div className='card'>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/umuxsqNE3fI?si=FS8uLYUSIZ9IIUDr&autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1&mute=1"
                title="YouTube video player"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>

            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/FBuyfpiz5FM?si=1WBI-i7VZMkkomEk&autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1&mute=1"
                title="YouTube video player"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>

          </div>


          <div id='contact' style={{translate: '0 -5rem'}}></div>
          <div className='card-title'>
            <h2>CONTACT US</h2>
          </div>

          <ContactForm />
        </div>
      </div>

      {/* {showCookieBanner && (
        <div className='cookie-popup'>
          <div className='cookie-popup-content'>
            <p>
              By using this site, you agree to our use of cookies to improve your experience.
            </p>
            <button onClick={handleCookieConsent}>Got it</button>
          </div>
        </div>
      )} */}

      <Footer />
    </>
  );
}

export default Home;
